var map = {
	"./eu_flag_yellow": 170,
	"./eu_flag_yellow.jpg": 170,
	"./newseye_logo": 171,
	"./newseye_logo.png": 171,
	"./newseye_logo_small": 172,
	"./newseye_logo_small.png": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;